export default __webpack_public_path__ + "static/media/banana.87638c12.png";